import flushPromises from 'flush-promises'

export const waitThenMouseOver = async (vDatePicker, callback = null) => {
  const timeoutId = setTimeout(async () => {
    const popoverComp = findPopoverComponent(vDatePicker)
    if (!popoverComp) {
      return
    }
    popoverComp.onMouseOver()
    await flushPromises()
    if (callback) {
      const popoverEl = popoverComp.popoverEl
      popoverEl.addEventListener('click', callback)
    }
  }, 100)
  return timeoutId
}

const findPopoverComponent = vDatePicker => {
  const isObject = arg => typeof arg === 'object' && arg !== null
  const hasChildren = parentComp =>
    isObject(parentComp) &&
    Object.hasOwn(parentComp, '$children') &&
    parentComp.$children.length > 0
  if (!hasChildren(vDatePicker)) {
    return null
  }
  const childA = vDatePicker.$children[0]
  if (!hasChildren(childA)) {
    return null
  }
  const childB = childA.$children[0]
  if (!hasChildren(childB)) {
    return null
  }
  return childB.$children[0]
}
